/**
 * All the access keys for the settings available 
 * @enum { string}
 *
 */
export enum AccessSettingsKeys {
    USERS = 'access_setting_users_access',
    GROUPS = 'access_setting_groups_access',
    WORKFLOWS = 'access_setting_workflows_access',
    VERSIONS = 'access_setting_versions_access',
    RULES = 'access_setting_rules_access',
    CATEGORIES = 'access_setting_categories_access',
    TOKENS = 'access_setting_tokens_access',
    FORMS = 'access_setting_custom_forms',
    ORGANIZATION_PROFILE = 'access_setting_organization_profile',
}

export interface AccessSettings {
    [AccessSettingsKeys.USERS]: boolean;
    [AccessSettingsKeys.GROUPS]: boolean;
    [AccessSettingsKeys.WORKFLOWS]: boolean;
    [AccessSettingsKeys.VERSIONS]: boolean;
    [AccessSettingsKeys.RULES]: boolean;
    [AccessSettingsKeys.CATEGORIES]: boolean;
    [AccessSettingsKeys.TOKENS]: boolean;
    [AccessSettingsKeys.FORMS]: boolean;
    [AccessSettingsKeys.ORGANIZATION_PROFILE]: boolean;
}